import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileUploadProcessComponent } from 'src/app/components/dialog';
import { DialogModalService } from 'src/app/services';

@Component({
  selector: 'ff-button-upload-files',
  templateUrl: './ff-button-upload-files.component.html',
  styleUrls: ['./ff-button-upload-files.component.css']
})
export class FfButtonUploadFilesComponent implements OnInit {

  @Input() label: string = 'Upload file';
  @Input() multiple: boolean = false;
  @Input() component: string = '';
  @Input() type: string = '';
  @Input() date: any = null;

  @Output() uploadedFiles = new EventEmitter();

  constructor(
    private dialogModal: DialogModalService,
  ) { }

  ngOnInit(): void {
  }


  /**
   * 
   * @param files FileList
   */
  selectFile(files: FileList): void {

    let data = {
      files: files,
      date: this.date,
      option: {
        multiple: this.multiple,
        component: this.component
      }
    }
    
    this.dialogModal.open(data, FileUploadProcessComponent).then(
      (result) => { 
  
        if(result){ 
          
          this.uploadedFiles.emit(result);
        }
      }, 
      () => { console.log('Rejected!'); }
    );
  }
}
